import { SplitViewCollection } from 'modelx-jts-common';
import EntityModel             from 'models/fondationsModels/EntityModel';
import EntityIdModel           from 'models/fondationsModels/EntityIdModel';
import { observable }          from 'mobx';

export class EntitySplitViewStore {
	@observable public entityCollection = new SplitViewCollection(EntityModel, EntityIdModel);
}

export const entitySplitViewStore = new EntitySplitViewStore();
